export default "__VITE_ASSET___OIGtMuQ__"